const constant = {
    uploadRules: {
        ORG_CERT: "营业执照或组织机构代码证",
        ORG_CERT_MSG: "请上传营业执照或组织机构代码证",

        AGENT_IDCARD: "身份证证件",
        AGENT_IDCARD_MSG: "请上传身份证证件",

        HOUSE_CERT: "房屋产权证",
        HOUSE_CERT_MSG: "请上传房屋产权证",

        APPLY_FORM: "申请表（盖章）",
        APPLY_FORM_MSG: "请上传申请表",

        WATER_CONTRACT: "供用水合同（盖章）",
        WATER_CONTRACT_MSG: "请上传供用水合同",

        TAXER_PROVE: "纳税人资格证明（盖章）",
        TAXER_PROVE_MSG: "请上传纳税人资格证明",

        TAX_TICKET: "增值税专票填开审批单",
        TAX_TICKET_MSG: "请上传增值税专票填开审批单",

        ONCE_NOTICE: "一次性告知书",
        ONCE_NOTICE_MSG: "请上传一次性告知书",

        ONCE_NOTICE_WATER: "接水报装一次性告知书",
        ONCE_NOTICE_WATER_MSG: "请上传接水报装一次性告知书",

        ONCE_NOTICE_FIRE: "消防用水一次性告知",
        ONCE_NOTICE_FIRE_MSG: "请上传消防用水一次性告知",

        REMOLD_PROTOCOL: "一户一表改造协议",
        REMOLD_PROTOCOL_MSG: "请上传一户一表改造协议",

        APPLY_EXPLAIN: "申请说明",
        APPLY_EXPLAIN_MSG: "请上传申请说明",

        EQUITY_CERT: "产权证或政府相关文件",
        EQUITY_CERT_MSG: "请上传产权证或政府相关文件",

        TICKET_FILE: "专票资料",
        TICKET_FILE_MSG: "请上传专票资料",

        MOVE_APPLY: "移位申请表",
        MOVE_APPLY_MSG: "请上传移位申请表",

        TAX_PEOPLE: "一般纳税人",
        TAX_PEOPLE_MSG: "请上传纳税人资料",

        OTHER_FILE: "其他资料",
        OTHER_FILE_MSG: "请上传其他资料",

        FIRE_CHART: "消防图纸或者消防流量联系单",
        FIRE_CHART_MSG: "请上传消防图纸或者消防流量联系单",

        YING_YE: "营业执照或组织机构代码证",
        YING_YE_MSG: "请上传营业执照或组织机构代码证",

        TU_PDF: "图纸（PDF格式）",
        TU_PDF_MSG: "请上传图纸（PDF格式）",

        SHI_GONG: '施工委托须知',
        SHI_GONG_MSG: "请上传施工委托须知",

        DING_DIAN: "定点红线图（基建）",
        DING_DIAN_MSG: "请上传定点红线图（基建）",

        DAN_TI: '单体建筑水施图（永久申请时提供）',
        DAN_TI_MSG: "请上传单体建筑水施图（永久申请时提供）",

        PAI_SHUI: "给排水及消防管线图（永久申请时提供）",
        PAI_SHUI_MSG: "请上传给排水及消防管线图（永久申请时提供）"
    },
    downloadInfo: {
        waterContract: '供用水合同',
        waterContractUrl: 'http://192.168.100.76:8010/downloaddoc/companydoc/单位供用水合同.doc',

        waterAccountChange: '单位用户结算水表变更户名申请表',
        waterAccountChangeUrl: 'http://192.168.100.76:8010/downloaddoc/companydoc/单位用户结算水表变更户名申请表.doc',

        waterBusinessChange: '自来水业务变更申请表',
        waterBusinessChangeUrl: 'http://192.168.100.76:8010/downloaddoc/companydoc/自来水业务变更申请表.doc',

        catchWaterApply: '单位水表暂停申请表',
        catchWaterApplyUrl: 'http://192.168.100.76:8010/downloaddoc/companydoc/单位水表暂停申请表.doc',

        connectWaterApply: '单位水表复接申请表',
        connectWaterApplyUrl: 'http://192.168.100.76:8010/downloaddoc/companydoc/单位水表复接申请表.doc',

        destroyWaterApply: '单位水表销户申请表',
        destroyWaterApplyUrl: 'http://192.168.100.76:8010/downloaddoc/companydoc/单位水表销户申请表.doc',

        taxTicketApproval: '增值税专用发票填开审批单',
        taxTicketApprovalUrl: 'http://192.168.100.76:8010/downloaddoc/companydoc/增值税专用发票填开审批单.doc',

        accountChange: '帐户变更申请表',
        accountChangeUrl: 'http://192.168.100.76:8010/downloaddoc/companydoc/帐户变更申请表.doc',

        onceTellWaterForm: '接水一次性告知申请表',
        onceTellWaterFormUrl: 'http://192.168.100.76:8010/downloaddoc/companydoc/接水一次性告知申请表.doc',

        onceTellFireForm: '消防用水一次性告知',
        onceTellFireFormUrl: 'http://192.168.100.76:8010/downloaddoc/companydoc/消防用水一次性告知.doc',

        onceTellForm: '一次性告知申请表',
        onceTellFormUrl: 'http://192.168.100.76:8010/downloaddoc/companydoc/一次性告知申请表.doc',

        waterChangeProtocol: '一户一表改造协议',
        waterChangeProtocolUrl: 'http://192.168.100.76:8010/downloaddoc/companydoc/一户一表改造协议.doc',

        moveApply: '移位申请表',
        moveApplyUrl: 'http://192.168.100.76:8010/downloaddoc/companydoc/移位申请表.doc',

        applyForm: '申请表',
        applyFormUrl: 'http://192.168.100.76:8010/downloaddoc/companydoc/申请表.doc',

        waterEntrust: '接水报装施工委托须知',
        waterEntrustUrl: 'http://192.168.100.76:8010/downloaddoc/companydoc/接水报装施工委托须知.doc',
    }
}

export default constant
